import React, { useState, useEffect, useRef } from "react";
import { Stack, Button, Modal, CircularProgress, Box } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useGetUserDetailsMutation } from "../../redux/api/authApi";
import {
  usePublishUnpublishCountMutation,
  useCampaignListMutation,
} from "../../redux/api/promptApi";
import {
  usePlanDetailsMutation,
  useLazyGetProductQuery,
} from "../../redux/api/productApi";
import { useAppSelector } from "../../redux/store";
import { IPlanDetail } from "../../redux/api/types";
import { getCookie } from "utils/storageUtils";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ContactUsModal from "../../components/ContactUsModal";

/* ─── SVG Icons ─── */
const IconCrown = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M2 18h20M4 18l2-9 6 5 4-9 4 13H4z" stroke="#d8b4fe" strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);
const IconXCircle = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="#93c5fd" strokeWidth="1.7" />
    <path d="M15 9l-6 6M9 9l6 6" stroke="#93c5fd" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);
const IconCard = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="6" width="20" height="13" rx="2.5" stroke="#7dd3fc" strokeWidth="1.7" />
    <path d="M2 11h20" stroke="#7dd3fc" strokeWidth="1.7" />
    <rect x="5" y="14" width="5" height="2" rx="0.7" fill="#7dd3fc" />
  </svg>
);
const IconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="#6b7280" strokeWidth="1.8" />
    <path d="M16 3v4M8 3v4M3 10h18" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
const IconArrow = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path d="M5 12h14M13 6l6 6-6 6" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const IconDownloadOutline = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3v12M7 11l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 20h16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const IconDownloadBlue = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
    <path d="M12 3v12M7 11l5 5 5-5" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 20h16" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
const IconInfo = ({ color = "#6b7280" }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.8" />
    <circle cx="12" cy="8" r="0.8" fill={color} />
    <path
      d="M12 11v5"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconMail = ({ color = "#d1d5db" }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect
      x="2"
      y="4"
      width="20"
      height="16"
      rx="2"
      stroke={color}
      strokeWidth="1.8"
    />
    <path
      d="M2 8l10 6 10-6"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconLock = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="#4b5563" strokeWidth="1.8" />
    <path d="M8 11V7a4 4 0 018 0v4" stroke="#4b5563" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

/* ─── Helpers ─── */
const getInfoIconCircleStyle = (color: string): React.CSSProperties => ({
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: color,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const Billing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { FromCampaign, userEmail, FromUpdatedCampaign } = location.state || {};

  const [userDets, setUserDets] = useState<any>();
  const [publishedUnpublishedCount] = useState<any>();
  const [planDetails, setPlanDetails] = useState<any>();
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaignListDatas, setCampaignListDatas] = useState<any>();
  const [billingDatas, setBillingDatas] = useState<any>();

  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [publishUnpublishCountMutation] = usePublishUnpublishCountMutation();
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const genieSelector = useAppSelector((state) => state.genieState);
  const [getProduct, getProductState] = useLazyGetProductQuery();
  const [campaignListMutation] = useCampaignListMutation();
  const [openActivateConfirmationModal, setOpenActivateConfirmationModal] = useState<boolean>(false);
  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openChangePaymentModal, setOpenChangePaymentModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const [isChangePaymentLoading, setIsChangePaymentLoading] = useState(false);
  const [contactUsOpen, setContactUsOpen] = useState(false);
  const isSubmitting = useRef(false);

  const useremail = localStorage.getItem("user_email") || "";

  /* ─── API calls (unchanged) ── */
  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: useremail || getCookie("user_email") || "",
        filter: "", start_date: "", end_date: "",
      });
      if ("data" in response) setUserDets(response.data.data);
    } catch (error) {}
  };
  useEffect(() => { fetchData(); }, []);

  const fetchingPublishDatas = async (campaignId: string) => {
    try {
      const responseCount = await publishUnpublishCountMutation({
        email: useremail || getCookie("user_email") || "",
        campaignid: campaignId,
      });
      if ("data" in responseCount) console.log(responseCount.data);
    } catch (error) {}
  };
  useEffect(() => { fetchingPublishDatas(""); }, []);

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({ email: useremail, campaignid: "" });
      if ("data" in response) setPlanDetails(response.data.data);
    } catch (error) {}
  };
  useEffect(() => { fetchPlanDatas(); }, []);

  const [plans] = useState<IPlanDetail[]>([{
    user: 1, plan_name: "", total_wishes: 0, price: "", period: "",
    product_id: "", price_id: "", subscription_level: "", feature: [],
    contracts: 0, type: "", button_text: "", save: "",
  }]);
  useEffect(() => {
    const { data } = getProductState;
    if (data?.plan_details) {
      // setPlans([...data.plan_details]);
    }
  }, [getProductState]);

  const campaignRes = async () => {
    try {
      const response = await campaignListMutation({ email: useremail || "" });
      if ("data" in response) setCampaignListDatas(response.data);
    } catch (error) {}
  };
  useEffect(() => { campaignRes(); }, []);

  useEffect(() => {
    const publishingblogCampId = localStorage.getItem("publishingCampId");
    if (publishingblogCampId) {
      setSelectedCampaign(publishingblogCampId);
      fetchingPublishDatas(publishingblogCampId);
    } else if (FromCampaign) {
      setSelectedCampaign(FromCampaign);
      fetchingPublishDatas(FromCampaign);
      localStorage.setItem("campId", FromCampaign);
      localStorage.setItem("refreshCount", "0");
    } else if (FromUpdatedCampaign) {
      setSelectedCampaign(FromUpdatedCampaign);
      fetchingPublishDatas(FromUpdatedCampaign);
      localStorage.setItem("campId", FromUpdatedCampaign);
    } else if (campaignListDatas && campaignListDatas.length > 0) {
      const savedCampId = localStorage.getItem("campId");
      if (!savedCampId) {
        setSelectedCampaign(campaignListDatas[0].campaign_id);
        fetchingPublishDatas(campaignListDatas[0].campaign_id);
        localStorage.setItem("campId", campaignListDatas[0].campaign_id);
      } else {
        setSelectedCampaign(savedCampId);
        fetchingPublishDatas(savedCampId);
      }
    }
  }, [campaignListDatas, FromCampaign, FromUpdatedCampaign]);

  const BillingLists = async () => {
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await axios.post(
        `${apiUrl}/api/payment/get_payment_list/?email=${useremail}`,
        null,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setBillingDatas(response.data.payments);
    } catch (error) {
      console.log("Error fetching billing details", error);
    }
  };
  useEffect(() => { BillingLists(); }, []);

  const handleActivateSubscription = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await fetch(
        apiUrl + `/api/subscription/activate_now/?email=${userEmail || useremail}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userEmail }),
        }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      toast.success(data.message);
      navigate("/activation-success");
    } catch (error) {
      toast.error("Error activating subscription");
      console.error("Error activating subscription:", error);
    } finally {
      isSubmitting.current = false;
      setIsLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsCancelLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await fetch(
        `${apiUrl}/api/subscription/Cancel_Subscription/?email=${encodeURIComponent(useremail)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      toast.success(data.message || "Subscription cancelled successfully.");
      setOpenCancelModal(false);
      fetchPlanDatas();
    } catch (error) {
      toast.error("Error cancelling subscription. Please try again.");
      console.error("Error cancelling subscription:", error);
    } finally {
      isSubmitting.current = false;
      setIsCancelLoading(false);
    }
  };

  const handleChangePaymentMethod = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsChangePaymentLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const response = await fetch(
        `${apiUrl}/api/subscription/change_payment_method/?email=${encodeURIComponent(useremail)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      // If API returns a redirect URL, open it
      const redirectUrl = data.portal_url || data.url;
      if (redirectUrl) {
        window.open(redirectUrl, "_blank");
        setOpenChangePaymentModal(false);
        return;
      }
      toast.success(data.message || "Payment method update initiated.");
      setOpenChangePaymentModal(false);
    } catch (error) {
      toast.error("Error updating payment method. Please try again.");
      console.error("Error changing payment method:", error);
    } finally {
      isSubmitting.current = false;
      setIsChangePaymentLoading(false);
    }
  };


  const getPlanLabel = (level: string) => {
    const map: Record<string, string> = {
      level_0: "STARTER", level_4: "STARTER",
      level_1: "CREATOR", level_5: "CREATOR",
      level_2: "PROFESSIONAL", level_6: "PROFESSIONAL",
      level_3: "ENTERPRISE", level_7: "ENTERPRISE",
      level_0a: "Life Time - STARTER",
      level_1a: "Life Time - CREATOR",
      level_2a: "Life Time - PROFESSIONAL",
      level_3a: "Life Time - ENTERPRISE",
    };
    return map[level] || "No Plan Subscribed";
  };

  const downloadTableAsCSV = () => {
    if (!billingDatas || billingDatas.length === 0) return;
    const headers = ["S.No", "Invoice No", "Mode", "Subscription Date", "Plan", "Amount"];
    const rows = billingDatas.map((data: any, index: number) => [
      index + 1, data.invoice_no, data.mode,
      new Date(data.subscription_date).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }),
      getPlanLabel(data.subscription_level),
      `$${Number(data.amount).toFixed(2)}`,
    ]);
    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Billing-Data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isLifeTimePlan = planDetails?.plan_name?.startsWith("Life Time");
  const hasPlan = !!planDetails?.plan_name;
  const canUpgrade =
    (parseInt(localStorage.getItem("free_plan") || "0") === 0 ||
      parseInt(localStorage.getItem("free_plan") || "1") ||
      ["level_1", "level_2", "level_3", "level_4", "level_5"].includes(
        localStorage.getItem("subscription_level") || ""
      )) && userDets?.payment_status !== "Free Trial";

  /* ══════════════ STYLES ══════════════ */
  const S: Record<string, React.CSSProperties> = {
    page: {
      background: "transparent",
      minHeight: "100vh",
      padding: "40px 40px 60px",
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      color: "#e5e7eb",
      boxSizing: "border-box",
    },
    pageTitle: {
      fontSize: 28, fontWeight: 700, color: "#ffffff",
      margin: "0 0 6px", letterSpacing: "-0.3px",
    },
    pageSub: {
      fontSize: 14, color: "#9ca3af", margin: "0 0 28px",
    },

    /* ── top cards row ── */
    cardsRow: {
      display: "flex", gap: 16, marginBottom: 40,
      flexWrap: "wrap" as const, alignItems: "stretch",
    },

    /* ── card 1: plan ── */
    planCard: {
      background: "#161b22",
      border: "1px solid #21262d",
      borderRadius: 12,
      padding: "20px 22px 22px",
      boxSizing: "border-box",
      flex: 1, minWidth: 220,
      display: "flex",
      flexDirection: "column",
    },
    planTopRow: {
      display: "flex", alignItems: "center", gap: 14, marginBottom: 18,
    },
    planIconCircle: {
      width: 44, height: 44, borderRadius: "50%",
      background: "rgba(168,139,250,0.15)",
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0,
    },
    planLabelSmall: {
      fontSize: 12, color: "#9ca3af",
      fontWeight: 500, marginBottom: 2,
    },
    planNameBig: {
      fontSize: 20, fontWeight: 700, color: "#a78bfa", lineHeight: 1.15,
    },
    planBilled: {
      fontSize: 12, color: "#6b7280", marginTop: 2,
    },

    nextBlock: {
      borderTop: "1px solid #21262d",
      paddingTop: 16, marginTop: "auto",
    },
    nextLabelRow: {
      display: "flex", alignItems: "center", gap: 6,
      fontSize: 12, color: "#9ca3af",
      fontWeight: 500, marginBottom: 4,
    },
    nextDate: {
      fontSize: 20, fontWeight: 700, color: "#ffffff", marginBottom: 4,
    },
    renewNote: {
      fontSize: 11, color: "#6b7280", marginBottom: 16,
    },
    upgradeBtn: {
      width: "100%",
      background: "#3b82f6",
      color: "#fff", border: "none", borderRadius: 8,
      padding: "10px 0", fontSize: 14, fontWeight: 600,
      cursor: "pointer", letterSpacing: "0.01em",
    },

    /* ── cards 2 & 3 ── */
    infoCard: {
      background: "#161b22",
      border: "1px solid #21262d",
      borderRadius: 12,
      padding: "22px 30px",
      boxSizing: "border-box",
      flex: 1, minWidth: 220,
      display: "flex",
      flexDirection: "column",
    },
    infoCardTop: {
      display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 10,
    },
    infoCardTitle: {
      fontSize: 15, fontWeight: 600, color: "#ffffff", marginBottom: 6,
    },
    infoCardBody: {
      fontSize: 13, color: "#9ca3af", lineHeight: 1.65,
    },
    actionLink: {
      display: "inline-flex", alignItems: "center", gap: 5,
      fontSize: 13, fontWeight: 500, color: "#3b82f6",
      background: "none", border: "none", padding: 0, cursor: "pointer",
      marginTop: 18,
    },

    /* ── section header ── */
    sectionHdr: {
      display: "flex", alignItems: "flex-end",
      justifyContent: "space-between",
      marginBottom: 18, flexWrap: "wrap" as const, gap: 10,
    },
    sectionTitle: { fontSize: 18, fontWeight: 700, color: "#fff", margin: "0 0 4px" },
    sectionSub: { fontSize: 13, color: "#9ca3af", margin: 0 },
    exportBtn: {
      display: "flex", alignItems: "center", gap: 7,
      background: "transparent",
      border: "1px solid #2a3246",
      color: "#3b82f6", borderRadius: 8,
      padding: "8px 16px", fontSize: 13, fontWeight: 500,
      cursor: "pointer", whiteSpace: "nowrap",
    },

    /* ── table wrapper ── */
    tableWrap: {
      background: "#161b22",
      border: "1px solid #21262d",
      borderRadius: 12,
      overflowX: "auto",
    },
    table: { width: "100%", borderCollapse: "collapse", minWidth: 580 },
    th: {
      padding: "14px 20px", textAlign: "left" as const,
      fontSize: 12, fontWeight: 500, color: "#9ca3af",
      borderBottom: "1px solid #21262d",
    },
    td: {
      padding: "14px 20px", fontSize: 13, color: "#d1d5db",
      borderBottom: "1px solid #1c2230",
    },
    tdLast: {
      padding: "14px 20px", fontSize: 13, color: "#d1d5db",
    },
    invLink: { color: "#3b82f6", fontWeight: 500, cursor: "pointer", textDecoration: "none" },
    paidBadge: {
      display: "inline-flex", alignItems: "center", gap: 6,
      background: "rgba(16,185,129,0.15)", color: "#10b981",
      borderRadius: 20, padding: "3px 12px",
      fontSize: 12, fontWeight: 600,
    },
    dlBtn: {
      background: "none", border: "none",
      cursor: "pointer", padding: "2px 4px",
      borderRadius: 5, lineHeight: 0,
      opacity: 0.6,
    },
    emptyCell: {
      textAlign: "center" as const, color: "#6b7280",
      padding: "44px 20px", fontSize: 14,
    },

    /* ── help row ── */
    helpRow: {
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      background: "#161b22",
      border: "1px solid #21262d",
      borderRadius: 12,
      padding: "20px 24px",
      marginTop: 24,
      flexWrap: "wrap" as const, gap: 14,
    },
    helpLeft: { display: "flex", alignItems: "flex-start", gap: 14 },
    helpIconCircle: {
      width: 38, height: 38, borderRadius: "50%",
      background:"rgba(59,130,246,0.15)",
      border: "1px solid #2a3246",
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0,
    },
    helpTitle: { fontSize: 14, fontWeight: 600, color: "#fff", marginBottom: 4 },
    helpSub: { fontSize: 13, color: "#6b7280", lineHeight: 1.55 },
    contactBtn: {
      display: "flex", alignItems: "center", gap: 8,
      background: "transparent",
      border: "1px solid #2a3246",
      color: "#3b82f6", borderRadius: 8,
      padding: "9px 18px", fontSize: 13, fontWeight: 500,
      cursor: "pointer", whiteSpace: "nowrap",
    },

    /* ── secure note ── */
    secureNote: {
      display: "flex", alignItems: "center",
      justifyContent: "center", gap: 6,
      marginTop: 24, fontSize: 12, color: "#4b5563",
    },
  };

  return (
    <>
      <div style={S.page}>

        {/* PAGE HEADER */}
        <p style={S.pageTitle}>Payment Details</p>
        <p style={S.pageSub}>
          {userDets?.role === 'student' ? "View your payment history." : "View your payment history, manage your subscription, and update your payment method."}
        </p>

        {/* ══ TOP CARDS ROW ══ */}
        {userDets?.role !== 'student' && (<div style={S.cardsRow}>

          {/* ─ Card 1: Current Plan  */}
          <div style={S.planCard}>
            <div style={S.planTopRow}>
              <div style={S.planIconCircle}>
                <IconCrown />
              </div>
              <div>
                <div style={S.planLabelSmall}>Current Plan</div>
                <div style={S.planNameBig}>
                  {planDetails?.plan_name ? planDetails.plan_name : "Non-Subscribed"}
                </div>
                {userDets?.payment_status === "Free Trial" && (
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>(Free Trial)</div>
                )}
                <div style={S.planBilled}>Billed Monthly</div>
              </div>
            </div>

            {hasPlan && !isLifeTimePlan && (
              <div style={S.nextBlock}>
                <div style={S.nextLabelRow}>
                  <IconCalendar />
                  Next Billing Date
                </div>
                <div style={S.nextDate}>
                  {planDetails?.expiry_date
                    ? new Date(planDetails.expiry_date).toLocaleDateString("en-US", {
                      month: "long", day: "2-digit", year: "numeric",
                    })
                    : "—"}
                </div>
                <div style={S.renewNote}>Your subscription will renew automatically.</div>

                {canUpgrade ? (
                  <button
                    style={S.upgradeBtn}
                    onClick={() => {
                      const value = {
                        _id: "", product_name: "CodeGenie",
                        product_module: genieSelector.module || "",
                        userid: "", productid: "",
                      };
                      getProduct(value);
                      localStorage.setItem("fromUpgrade", "true");
                      localStorage.setItem("activeItem", "upgrade");
                      setTimeout(() => { window.location.reload(); }, 100);
                      navigate("/codegenie/generated-blogs", {
                        state: { campIdFromUpgrade: selectedCampaign, from_page: "blog_listing" },
                      });
                    }}
                  >
                    Upgrade Plan
                  </button>
                ) : (
                  <button
                    style={S.upgradeBtn}
                    onClick={() => setOpenActivateConfirmationModal(true)}
                  >
                    Activate
                  </button>
                )}
              </div>
            )}
          </div>

          {/* ─ Card 2: Cancel Subscription ─ */}
          <div style={S.infoCard}>
            <div style={S.infoCardTop}>
              <div style={getInfoIconCircleStyle("rgba(59,130,246,0.15)")}>
                <IconXCircle />
              </div>
              <div>
                <div style={S.infoCardTitle}>Cancel Subscription</div>
                <div style={S.infoCardBody}>
                  Cancel your subscription.<br />
                  You'll keep access until the<br />
                  end of your billing period.
                </div>
              </div>
            </div>
            <button
              style={{
                width: "100%",
                background: "rgba(239,68,68,0.12)",
                color: "#f87171",
                border: "1px solid rgba(239,68,68,0.3)",
                borderRadius: 8,
                padding: "10px 0",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                letterSpacing: "0.01em",
                marginTop: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
              }}
              onClick={() => setOpenCancelModal(true)}
            >
              Cancel Subscription <IconArrow />
            </button>
          </div>

          {/* ─ Card 3: Change Payment Method ─ */}
          <div style={S.infoCard}>
            <div style={S.infoCardTop}>
              <div style={getInfoIconCircleStyle("rgba(14,165,233,0.15)")}>
                <IconCard />
              </div>
              <div>
                <div style={S.infoCardTitle}>Change Payment Method</div>
                <div style={S.infoCardBody}>
                  Update your payment<br />
                  method or card details.
                </div>
              </div>
            </div>
            <button
              style={{
                width: "100%",
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "10px 0",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                letterSpacing: "0.01em",
                marginTop: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
              }}
              onClick={handleChangePaymentMethod}
              disabled={isChangePaymentLoading}
            >
              {isChangePaymentLoading ? "Redirecting..." : <>"Update Payment Method" <IconArrow /></>}
            </button>
          </div>

        </div>)}

        {/* ═ PAYMENT HISTORY ══ */}
        <div style={S.sectionHdr}>
          <div>
            <p style={S.sectionTitle}>Payment History</p>
            <p style={S.sectionSub}>View and download your past payments.</p>
          </div>
      <button style={S.exportBtn} onClick={downloadTableAsCSV}>
  <span style={{ color: "#3b82f6" }}>
    <IconDownloadOutline />
  </span>
  Export All Invoices
</button>
        </div>

        {/* TABLE */}
        <div style={S.tableWrap}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Invoice No</th>
                <th style={S.th}>Date</th>
                <th style={S.th}>Description</th>
                <th style={S.th}>Amount</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {billingDatas && billingDatas.length > 0 ? (
                billingDatas.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={S.td}>
                      <span style={S.invLink} onClick={downloadTableAsCSV} title="Click to download">
                        {data.invoice_no}
                      </span>
                    </td>
                    <td style={S.td}>
                      {new Date(data.subscription_date).toLocaleDateString("en-US", {
                        month: "short", day: "2-digit", year: "numeric",
                      })}
                    </td>
                    <td style={S.td}>
                      {getPlanLabel(data.subscription_level)} Plan – {data.mode || "Monthly"}
                    </td>
                    <td style={{ ...S.td, fontWeight: 600, color: "#fff" }}>
                      ${Number(data.amount).toFixed(2)}
                    </td>
                    <td style={S.td}>
                      <span style={S.paidBadge}>
                        <svg width="6" height="6" viewBox="0 0 6 6">
                          <circle cx="3" cy="3" r="3" fill="#10b981" />
                        </svg>
                        Paid
                      </span>
                    </td>
                    <td style={index === billingDatas.length - 1 ? S.tdLast : S.td}>
                      <button style={S.dlBtn} onClick={downloadTableAsCSV} title="Download invoice">
                        <IconDownloadBlue />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={S.emptyCell}>No Records Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ══ HELP FOOTER ══ */}
        <div style={S.helpRow}>
          <div style={S.helpLeft}>
            <div style={S.helpIconCircle}>
              <IconInfo color=  "#3b82f6" />
            </div>
            <div>
              <div style={S.helpTitle}>Need help?</div>
              <div style={S.helpSub}>
                If you have any questions about your billing, payments, or subscription,<br />
                our support team is here to help.
              </div>
            </div>
          </div>
          <button style={S.contactBtn} onClick={() => setContactUsOpen(true)}>
            <IconMail color ="#3b82f6" />
            Contact Support
          </button>
        </div>

        {/* ══ SECURE NOTE ══ */}
        <div style={S.secureNote}>
          <IconLock />
          All payments are secure and encrypted.
        </div>

      </div>

      {/* ═ ACTIVATE MODAL ══ */}
      <Modal
        open={openActivateConfirmationModal}
        onClose={() => setOpenActivateConfirmationModal(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%", left: "50%",
            display: "flex", flexDirection: "column", alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 600,
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            pt: 2, px: 4, pb: 3,
          }}
        >
          <p id="child-modal-description" style={{ textAlign: "center" }}>
            Activate Plan will immediately start your paid plan and bill your credit card.
            <br />CONTINUE?
          </p>
          <Stack flexDirection="row">
            <Button onClick={handleActivateSubscription} variant="contained" sx={{ mr: 2 }} disabled={isLoading}>
              {isLoading ? <CircularProgress style={{ color: "#fff" }} size={24} /> : "Yes"}
            </Button>
            <Button onClick={() => setOpenActivateConfirmationModal(false)} variant="contained" sx={{ mr: 2 }}>
              No
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* ═ CANCEL SUBSCRIPTION MODAL ══ */}
      <Modal
        open={openCancelModal}
        onClose={() => setOpenCancelModal(false)}
        aria-labelledby="cancel-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%", left: "50%",
            display: "flex", flexDirection: "column", alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 480,
            bgcolor: "#161b22",
            border: "1px solid #21262d",
            borderRadius: "10px",
            boxShadow: 24,
            pt: 3, px: 4, pb: 3,
          }}
        >
          <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
          <p id="cancel-modal-title" style={{ textAlign: "center", color: "#fff", fontWeight: 700, fontSize: 18, margin: "0 0 8px" }}>
            Cancel Subscription
          </p>
          <p style={{ textAlign: "center", color: "#9ca3af", fontSize: 13, lineHeight: 1.6, margin: "0 0 24px" }}>
            Are you sure you want to cancel your subscription?<br />
            You'll keep access until the end of your current billing period.
          </p>
          <Stack flexDirection="row" gap={2}>
            <Button
              onClick={handleCancelSubscription}
              variant="contained"
              color="error"
              disabled={isCancelLoading}
              sx={{ minWidth: 120 }}
            >
              {isCancelLoading ? <CircularProgress style={{ color: "#fff" }} size={22} /> : "Yes, Cancel"}
            </Button>
            <Button onClick={() => setOpenCancelModal(false)} variant="outlined" sx={{ minWidth: 100, borderColor: "#21262d", color: "#9ca3af" }}>
              Keep Plan
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* ═ CHANGE PAYMENT METHOD MODAL ══ */}
      <Modal
        open={openChangePaymentModal}
        onClose={() => setOpenChangePaymentModal(false)}
        aria-labelledby="change-payment-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%", left: "50%",
            display: "flex", flexDirection: "column", alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 480,
            bgcolor: "#161b22",
            border: "1px solid #21262d",
            borderRadius: "10px",
            boxShadow: 24,
            pt: 3, px: 4, pb: 3,
          }}
        >
          <div style={{ fontSize: 36, marginBottom: 12 }}>💳</div>
          <p id="change-payment-modal-title" style={{ textAlign: "center", color: "#fff", fontWeight: 700, fontSize: 18, margin: "0 0 8px" }}>
            Update Payment Method
          </p>

          <p style={{ textAlign: "center", color: "#9ca3af", fontSize: 13, lineHeight: 1.6, margin: "0 0 24px" }}>
            You'll be redirected to securely update your payment details.<br />
            Your subscription will continue without interruption.
          </p>
          <Stack flexDirection="row" gap={2}>
            <Button
              onClick={handleChangePaymentMethod}
              variant="contained"
              disabled={isChangePaymentLoading}
              sx={{ minWidth: 140, background: "#3b82f6" }}
            >
              {isChangePaymentLoading ? <CircularProgress style={{ color: "#fff" }} size={22} /> : "Update Payment"}
            </Button>
            <Button onClick={() => setOpenChangePaymentModal(false)} variant="outlined" sx={{ minWidth: 100, borderColor: "#21262d", color: "#9ca3af" }}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>

      <ContactUsModal
        open={contactUsOpen}
        onClose={() => setContactUsOpen(false)}
        userDets={userDets}
      />
    </>
  );
};

export default Billing;